import { render, staticRenderFns } from "./IncorporationFormFilesDetails.vue?vue&type=template&id=1d63498e&scoped=true&"
import script from "./IncorporationFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./IncorporationFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncorporationFormFilesDetails.vue?vue&type=style&index=0&id=1d63498e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63498e",
  null
  
)

export default component.exports